import { Form, Input, Select, Typography } from "antd";
import React, { useState } from "react";
import DeselectableRadioGroup from "../../../blocks/FormItems/DeselectableRadioGroup";
import inputStyles from "../../../styles/Custom/Input.module.css";
const lowHighOptions = [
  { label: "Low", value: "low" },
  { label: "Medium", value: "medium" },
  { label: "High", value: "high" },
];
const foodTypeOptions = [
  { label: "RT/Tube feeds", value: "rt_tube_feeds" },
  { label: "Oral liquid diet", value: "oral_liquid_diet" },
  { label: "Oral soft diet", value: "oral_soft_diet" },
  { label: "Oral regular diet", value: "oral_regular_diet" },
];
const DietPlan = ({ form }) => {
  const [refresh, setRefresh] = useState(false);

  const renderSelect = (name, options, placeholder = null) => (
    <Form.Item name={name} style={{ display: "inline-block" }}>
      <Select
        className={inputStyles.mdInput}
        style={{ width: "100px", marginLeft: 5, marginRight: 5 }}
        options={options}
        placeholder={placeholder}
      />
    </Form.Item>
  );
  return (
    <>
      <br />
      <Typography.Text>A</Typography.Text>
      {renderSelect("protein", lowHighOptions)}
      <Typography.Text>protein,</Typography.Text>
      {renderSelect("fat", lowHighOptions)}
      <Typography.Text>fat,</Typography.Text>
      {renderSelect("carbohydrate", lowHighOptions)}
      <Typography.Text>carbohydrate,</Typography.Text>
      {renderSelect("salt", lowHighOptions)}
      <Typography.Text>salt,</Typography.Text>
      {renderSelect("fiber", lowHighOptions)}
      <Typography.Text>fiber,</Typography.Text>
      {renderSelect("diet", lowHighOptions)}
      <Typography.Text>diet was planned.</Typography.Text>
      <br />
      <DeselectableRadioGroup
        name={"type_of_food"}
        label={"Type of food patient was on"}
        options={foodTypeOptions}
        form={form}
        setRefresh={setRefresh}
      />
      <br />
      <Form.Item
        style={{ display: "inline-block" }}
        name="recommended_protein"
        label="Recommended protein content of"
      >
        <Input style={{ width: "250px" }} addonAfter="grams/Kg/Day" />
      </Form.Item>
      <br />
      <Form.Item
        style={{ display: "inline-block" }}
        name="recommended_calories"
        label="Recommended calories of"
      >
        <Input style={{ width: "250px" }} addonAfter="/Day" />
      </Form.Item>
    </>
  );
};

export default DietPlan;
